import "./semLancamento.css";

function SemLancamento(){
    return(
        <div className="geralCard">
            <h1>Você ainda não possui nenhum lançamento</h1>
        </div>
    );
}

export default SemLancamento;